import { HoldBalanceHistoryMapper } from "@/data/persistences/mappers/HoldBalanceHistoryMapper";
import { Endpoints } from "../../misc/Endpoints";
import ApiService from "../../services/ApiService";
import { HoldBalanceHistoryRepositoryInterface } from "@/data/persistences/repositories/contracts/HoldBalanceHistoryRepositoryInterface";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { ApiRequestList } from "@/domain/entities/MainApp";

export class HoldBalanceHistoryApiRepository
  implements HoldBalanceHistoryRepositoryInterface {
  private service: ApiService;
  private mapper: HoldBalanceHistoryMapper;
  private endpoints: Endpoints;

  constructor(
    service: ApiService,
    mapper: HoldBalanceHistoryMapper,
    endpoints: Endpoints
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getList(params: ApiRequestList): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "GET",
      this.endpoints.getHoldBalanceHistoryList(params),
      {}
    );
    return this.mapper.convertListDataFromApi(resp);
  }
}
